import React from "react";
import MapProvider from "./MapProvider";
import MapView from "./MapView";
/**
 * This renders both a `<MapProvider>` and a `<MapView>`. Children of this
 * component will be rendered under the `<MapView>`. Use `<MapProvider>` and
 * `<MapView>` directly for more detailed control.
 *
 * If the provided projection is a string (e.g. `"EPSG:32633"`), and the
 * projection definition is not already loaded, the definition is loaded from
 * epsg.io automatically. Use `proj4.def()` and `ol/proj/proj4/register()` to
 * avoid this.
 *
 * Note: `center` and `zoom`, or `extent`, must be set to render any content.
 */
export default function Map({ projection = "EPSG:3857", children, background = "white", width = "100%", height = "100%", className, staticSize = false, ...mapOptions }) {
    return (React.createElement(MapProvider, { ...mapOptions, projection: projection },
        React.createElement(MapView, { width: width, height: height, background: background, className: className, staticSize: staticSize }, children)));
}
